/* eslint-disable camelcase */
import axios from 'axios';

import { SALE_RATE_INDEXING_RULE_ENDPOINT } from '@dynameat/constants';

export const saleRateIndexingRuleListRequest = (changed_sale_rate__point_of_sale__guid) => axios.get(
  SALE_RATE_INDEXING_RULE_ENDPOINT(), { params: { changed_sale_rate__point_of_sale__guid } }
);

export const createSaleRateIndexingRuleRequest = (saleRateIndexingRule) => axios.post(
  SALE_RATE_INDEXING_RULE_ENDPOINT(), saleRateIndexingRule
);

export const updateSaleRateIndexingRuleRequest = (saleRateIndexingRule) => axios.patch(
  SALE_RATE_INDEXING_RULE_ENDPOINT(saleRateIndexingRule.guid), saleRateIndexingRule
);

export const removeSaleRateIndexingRuleRequest = (saleRateIndexingRuleGuid) => axios.delete(
  SALE_RATE_INDEXING_RULE_ENDPOINT(saleRateIndexingRuleGuid)
);
